import axios from 'axios'
import qs from 'qs'
// import request from 'superagent'

const instance = axios.create({
  timeout: 20000,
  withCredentials: true
})

instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
instance.interceptors.response.use(function (response) {
  // Do something with response data
  return response
}, function (error) {
  // Do something with response error
  return Promise.reject(error)
})

// const handleResponse = function (err, response, cb) {
//   if (err) {
//     console.log('==========网络错误')
//   } else {
//     const res = JSON.parse(response.text)
//     cb(res)
//   }
// }
//
// export const getTest = function (url, data, cb) {
//   request.get(url)
//     .query(data)
//     .end(function (err, response) {
//       handleResponse(err, response, cb)
//     })
// }

export const get = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    instance.get(url, { params }).then((response) => {
      resolve(response.data)
      // if (response.data.code === 401) {
      //   window.location.href = 'emobile:{"func":"closeClick"}'
      //   return false
      // } else {
      //   resolve(response.data)
      // }
    }, err => {
      reject(err)
    })
  })
}

export const post = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    instance.post(url, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((response) => {
      resolve(response.data)
      // if (response.data.code === 401) {
      //   window.location.href = 'emobile:{"func":"closeClick"}'
      //   return false
      // } else {
      //   resolve(response.data)
      // }
    }, err => {
      reject(err)
    })
  })
}

export const postjson = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    instance.post(url, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      resolve(response.data)
      // if (response.data.code === 401) {
      //   window.location.href = 'emobile:{"func":"closeClick"}'
      //   return false
      // } else {
      //   resolve(response.data)
      // }
    }, err => {
      resolve(err)
    })
  })
}

export const postfile = (url, data) => {
  return new Promise((resolve, reject) => {
    instance.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
      resolve(response.data)
      // if (response.data.code === 401) {
      //   window.location.href = 'emobile:{"func":"closeClick"}'
      //   return false
      // } else {
      //   resolve(response.data)
      // }
    }, err => {
      resolve(err)
    })
  })
}
